import React from 'react';
import { format } from 'date-fns';
import shield from 'assets/images/icons/shield.svg';
import styles from './ProductMetaCard.module.scss';

type MetaCardProduct = {
  date: string;
  name: string;
};

const ProductMetaCard = ({ name, date }: MetaCardProduct) => {
  const formattedDate = format(new Date(date), 'do MMMM yyyy');

  return (
    <div className={styles.container}>
      <img src={shield} width="24px" alt="insurance icon" />
      <div className={styles.textContainer}>
        <p className={styles.productName}>{name}</p>
        <p className={styles.productDate}>{formattedDate}</p>
      </div>
    </div>
  )
};

export default ProductMetaCard;
